/*                                                                     */
import { DEV } from 'esm-env';
import * as e from './errors.js';
import { active_effect, active_reaction } from './runtime.js';
import { create_user_effect } from './reactivity/effects.js';
import { async_mode_flag, legacy_mode_flag } from '../flags/index.js';
import { FILENAME } from '../../constants.js';
import { BRANCH_EFFECT, EFFECT_RAN } from './constants.js';

/*                                  */
export let component_context = null;

/*                                           */
export function set_component_context(context) {
	component_context = context;
}

/*                               */
export let dev_stack = null;

/*                                      */
export function set_dev_stack(stack) {
	dev_stack = stack;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function add_svelte_meta(callback, type, component, line, column, additional) {
	const parent = dev_stack;

	dev_stack = {
		type,
		file: component[FILENAME],
		line,
		column,
		parent,
		...additional
	};

	try {
		return callback();
	} finally {
		dev_stack = parent;
	}
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export let dev_current_component_function = null;

/*                                           */
export function set_dev_current_component_function(fn) {
	dev_current_component_function = fn;
}

/**
 *
 *
 *
 */
export function createContext() {
	const key = {};

	return [
		() => {
			if (!hasContext(key)) {
				e.missing_context();
			}

			return getContext(key);
		},
		(context) => setContext(key, context)
	];
}

/**
 *
 *
 *
 *
 *
 *
 */
export function getContext(key) {
	const context_map = get_or_init_context_map('getContext');
	const result = /*            */ (context_map.get(key));
	return result;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function setContext(key, context) {
	const context_map = get_or_init_context_map('setContext');

	if (async_mode_flag) {
		var flags = /*                 */ (active_effect).f;
		var valid = !active_reaction && (flags & BRANCH_EFFECT) !== 0 && (flags & EFFECT_RAN) === 0;

		if (!valid) {
			e.set_context_after_init();
		}
	}

	context_map.set(key, context);
	return context;
}

/**
 *
 *
 *
 *
 *
 */
export function hasContext(key) {
	const context_map = get_or_init_context_map('hasContext');
	return context_map.has(key);
}

/**
 *
 *
 *
 *
 *
 *
 */
export function getAllContexts() {
	const context_map = get_or_init_context_map('getAllContexts');
	return /*            */ (context_map);
}

/**
 *
 *
 *
 *
 */
export function push(props, runes = false, fn) {
	component_context = {
		p: component_context,
		c: null,
		e: null,
		s: props,
		x: null,
		l: legacy_mode_flag && !runes ? { s: null, u: null, $: [] } : null
	};

	if (DEV) {
		/*                 */
		component_context.function = fn;
		dev_current_component_function = fn;
	}
}

/**
 *
 *
 *
 */
export function pop(component) {
	var context = /*                           */ (component_context);
	var effects = context.e;

	if (effects !== null) {
		context.e = null;

		for (var fn of effects) {
			create_user_effect(fn);
		}
	}

	if (component !== undefined) {
		context.x = component;
	}

	component_context = context.p;

	if (DEV) {
		dev_current_component_function = component_context?.function ?? null;
	}

	return component ?? /*            */ ({});
}

/*                     */
export function is_runes() {
	return !legacy_mode_flag || (component_context !== null && component_context.l === null);
}

/**
 *
 *
 */
function get_or_init_context_map(name) {
	if (component_context === null) {
		e.lifecycle_outside_component(name);
	}

	return (component_context.c ??= new Map(get_parent_context(component_context) || undefined));
}

/**
 *
 *
 */
function get_parent_context(component_context) {
	let parent = component_context.p;
	while (parent !== null) {
		const context_map = parent.c;
		if (context_map !== null) {
			return context_map;
		}
		parent = parent.p;
	}
	return null;
}
